import { useRouter } from 'next/router'

export default function useUrlTabController<T extends string>({
  queryKey,
  tabToQueryParam,
  defaultTab,
}: {
  queryKey: string
  defaultTab: T
  tabToQueryParam: { [key in T]: string }
}): [T, (tab: T) => string] {
  const router = useRouter()
  const currentTab =
    Object.keys(tabToQueryParam)
      .map(t => t as T)
      .find(t => tabToQueryParam[t] === router.query[queryKey]) ?? defaultTab

  const tabToUrl = (tab: T) => {
    const urlSearchParams = new URLSearchParams(Object.entries(router.query) as string[][])
    urlSearchParams.set(queryKey, tabToQueryParam[tab])
    return `${router.pathname}?${urlSearchParams.toString()}`
  }

  return [currentTab, tabToUrl]
}
